module.exports = __webpack_public_path__ + "img/st1.f5adf26e.png";